/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const $ = require('jquery')
$(function () {
  $('.js-search-modal-open').on('touchend', function () {
    $('.js-modal-search').fadeIn()
    return false
  })
  $('.js-modal-close').on('touchend', function () {
    $('.js-modal-search').fadeOut()
    return false
  })
})
